document.addEventListener('click', (e) => {
    const btn = e.target.closest('.translate-page');
    if (!btn) return;
    e.preventDefault();

    // Dev creds - remove these once ready for live launch
    const user = 'giant';
    const pass = 'giant';

    // Grab the raw hostname, path & query
    const { hostname: rawHost, pathname, search } = window.location;

    // Check for your dev domain - only for testing on dev
    const isDev = rawHost.endsWith('giantmade.net');

    // Build proxyHost:
    // - DEV:   replace every '-' → '--', then every '.' → '-'
    // - OTHER: just replace '.' → '-'
    const mangled = isDev
        ? rawHost.replace(/-/g, '--').replace(/\./g, '-')
        : rawHost.replace(/\./g, '-');

    const authProxy = `${user}:${pass}@${mangled}.translate.goog`;

    const proxyUrl = new URL(`https://${authProxy}${pathname}`);
    proxyUrl.search = [
        search.replace(/^\?/, ''),
        '_x_tr_sl=auto',
        '_x_tr_tl=en',
        '_x_tr_hl=en-GB',
        '_x_tr_pto=wapp'
    ].filter(Boolean).join('&');

    // Redirect
    window.location.assign(proxyUrl.toString());
});
